/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subtitle_Export_Keyword_SportsInputs */

const en_subtitle_export_keyword_sports = /** @type {(inputs: Subtitle_Export_Keyword_SportsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sports`)
};

const fr_subtitle_export_keyword_sports = /** @type {(inputs: Subtitle_Export_Keyword_SportsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sportif`)
};

const de_subtitle_export_keyword_sports = /** @type {(inputs: Subtitle_Export_Keyword_SportsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sport`)
};

const it_subtitle_export_keyword_sports = /** @type {(inputs: Subtitle_Export_Keyword_SportsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sport`)
};

const ru_subtitle_export_keyword_sports = /** @type {(inputs: Subtitle_Export_Keyword_SportsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Спорт`)
};

const es_subtitle_export_keyword_sports = /** @type {(inputs: Subtitle_Export_Keyword_SportsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deportes`)
};

const zh_cn2_subtitle_export_keyword_sports = /** @type {(inputs: Subtitle_Export_Keyword_SportsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`运动的`)
};

const ja_subtitle_export_keyword_sports = /** @type {(inputs: Subtitle_Export_Keyword_SportsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`スポーツ`)
};

const hi_subtitle_export_keyword_sports = /** @type {(inputs: Subtitle_Export_Keyword_SportsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`खेल`)
};

const pt_pt2_subtitle_export_keyword_sports = /** @type {(inputs: Subtitle_Export_Keyword_SportsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esportes`)
};

/**
* | output |
* | --- |
* | "Sports" |
*
* @param {Subtitle_Export_Keyword_SportsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const subtitle_export_keyword_sports = /** @type {((inputs?: Subtitle_Export_Keyword_SportsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subtitle_Export_Keyword_SportsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_subtitle_export_keyword_sports(inputs)
	if (locale === "de") return de_subtitle_export_keyword_sports(inputs)
	if (locale === "it") return it_subtitle_export_keyword_sports(inputs)
	if (locale === "ru") return ru_subtitle_export_keyword_sports(inputs)
	if (locale === "es") return es_subtitle_export_keyword_sports(inputs)
	if (locale === "zh-CN") return zh_cn2_subtitle_export_keyword_sports(inputs)
	if (locale === "ja") return ja_subtitle_export_keyword_sports(inputs)
	if (locale === "hi") return hi_subtitle_export_keyword_sports(inputs)
	if (locale === "pt-PT") return pt_pt2_subtitle_export_keyword_sports(inputs)
	return en_subtitle_export_keyword_sports(inputs)
});